import { VivElement, defineComponent } from './base.js';
import { escapeHtml } from '../core/htmlEscape.js';

/**
 * `<viv-chip label="TSV Muster" [removable] [title="…"]></viv-chip>`
 * Emits a cancelable `viv-remove` event when the remove icon is clicked.
 */
export class VivChip extends VivElement {
    static get observedAttributes(): string[] {
        return ['label', 'removable', 'title'];
    }

    protected render(): void {
        const label = this.attr('label');
        const title = this.attr('title');
        const removable = this.hasFlag('removable');
        this.className = 'vivDs-chip';
        if (title) this.setAttribute('data-viv-title', title);
        this.innerHTML = `<span${title ? ` title="${escapeHtml(title)}"` : ''}>${escapeHtml(label)}</span>${removable ? '<i class="fas fa-times vivDs-chipRemove" aria-hidden="true"></i>' : ''}`;

        if (removable && !this.dataset.vivBound) {
            this.dataset.vivBound = '1';
            this.addEventListener('click', (event) => {
                const target = event.target as HTMLElement;
                if (target.classList.contains('vivDs-chipRemove')) {
                    this.dispatchEvent(new CustomEvent('viv-remove', { bubbles: true, detail: { label: this.attr('label') } }));
                }
            });
        }
    }
}

export function registerVivChip(): void {
    defineComponent('viv-chip', VivChip);
}
